<template>
  <div v-if="store.moments.length" :class="`events-${store.moments.length >= 3 ? '3' : store.moments.length} ${props.swiper ? 'swiper-wrapper' : ''}`">
    <a
      v-for="(card, index) in store.moments"
      :key="index"
      :href="card.cta_url"
      role="button"
      :class="`card ${props.swiper ? 'swiper-slide' : ''} custom_click_track`"
      target="_blank"
      :custom_click_track_value="trackingAttr(store.selectedCard.tracking_version, 'MOMENTS', card.event_id)"
    >
      <div :class="store.moments.length !== 1 ? 'img-container-3-2' : 'img-wrap'">
        <img src="" :data-src="card.image" :alt="card.image_alt" class="img-thumbnail-3-2 lazy">
      </div>
      <div class="copy-wrap w-100 h-100">
        <div class="d-flex flex-column w-100 h-100">
          <div class="location-dates d-flex flex-column text-center w-100 px-2 py-1">
            <p class="label mb-0-5">{{ card.location }}</p>
            <p class="font-swiss-italic fz-2xs">{{ card.event_date }}</p>
          </div>
          <div class="d-flex flex-column flex-auto text-center pt-2 px-2 pb-3">
            <h4 class="card-title mb-0" v-html="card.title"></h4>
            <p class="bolder pt-1 pb-2 mb-auto">{{ card.price }}</p>
            <div class="mt-auto">
              <p class="btn-1 m-0">{{ card.cta_title }}</p>
              <p class="font-swiss-regular fz-3xs pt-2">{{ card.close_date }}</p>
            </div>
          </div>
        </div>
      </div>
    </a>
  </div>
  <div v-if="props.swiper" class="swiper-pagination"></div>

  <div v-if="store.moments.length === 0" class="coming-soon">
    <div class="card d-flex flex-column flex-md-row">
      <img src="" :data-src="`${store.baseUrl}/images/moments-coming-soon_d.jpg`" class="d-none d-md-block lazy" alt="">
      <img src="" :data-src="`${store.baseUrl}/images/moments-coming-soon_m.jpg`" class="d-md-none lazy" alt="">
      <div class="text-center d-flex justify-content-center align-items-md-center w-100 pt-3 pb-4 px-2">
        <div>
          <h4 class="heading-caps fz-xs mb-1">Coming Soon</h4>
          <p class="card-title fz-sm">Unforgettable Experiences <br>Just for <span class="no-wrap">Card Members</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { trackingAttr } from '../utilities';
import { useStore } from '../store';

const props = defineProps({
  swiper: Boolean,
});

const store = useStore();
</script>
